import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AddinfoDataGroup, AddinfoGroup } from 'src/app/models/addinfo.model';
import { ApiOrganizationsService, DialogModalService, FilesService, NotificationService } from 'src/app/services';

import { AddinfoService } from 'src/app/services/addinfo.service';
import { AttachingCertificateComponent, TagsListComponent } from '../../dialog';
import { FileData, Lang } from 'src/app/models';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DonwloadFileFromStorageComponent } from '../../dialog/files/donwload-file-from-storage/donwload-file-from-storage.component';
import { UploadFileWithDateComponent } from '../../dialog/files/upload-file-with-date/upload-file-with-date.component';


@Component({
  selector: 'app-addinfo',
  templateUrl: './addinfo.component.html',
  styleUrls: ['./addinfo.component.css']
})
export class AddinfoComponent implements OnInit {

  storage: any[] = [];
  attrType: any;
  attrValueType: any;

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  subscriptionForm: Subscription;

  addinfoGroups: AddinfoGroup[] = [];
  addinfoData: AddinfoDataGroup[] = [];

  urlElements: any[];
  objectId: number;

  integrationIds:string[] = [];

  // images:any[][] = [];
  isClicked: boolean[] = [];
  activeIds:string[] = ['panel-0'];
  fileIds:any[] = [];
  isRefreshingSpecs: boolean = false;

  action = {
    create: 'create',
    edit: 'edit'
  }

  currentAction: string = 'create';

  selectors: string[] = [];
  selectorObject: any = {};

  objectData = {
    id: null,
    name: '',
    action: ''
  }

  ffInputLang: any = { name: '', valid: false };

  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  currentOrg: any;

  attrName: Lang;

  @Input() set doAction(value: any) {

    if (value == 'update') {
      
      this.currentAction = value;
      this.updateAddinfoData();
    }
  }

  @Input() set setObjectData(value: any) {

    if (value) {

      this.objectData = value;
    }
  }

  @Output() gettedSpecificationsEvent = new EventEmitter();
  @Output() gettedDataEvent = new EventEmitter();
  @Output() updatedEvent = new EventEmitter();

  addinfoForm = this.fb.group({
    groups: this.fb.array([]),
  });

  constructor(
    private fb: UntypedFormBuilder,
    public ngProgress: NgProgress,
    private router: Router,
    private currentRoute: ActivatedRoute,
    private dialogModal: DialogModalService,
    private addinfoService: AddinfoService,
    private notification: NotificationService,
    private filesService: FilesService,
    private cdr: ChangeDetectorRef,
    private apiOrganizations: ApiOrganizationsService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.urlElements = this.router.url.split('/');
    this.attrType = this.addinfoService.attrType;
    this.attrValueType = this.addinfoService.attrValueType;
    this.currentOrg = this.apiOrganizations.currentOrganization;
    this.currentAction = this.urlElements[2];
    

    // this.currentAction == 'create' ? this.activeIds = ['panel-0'] : this.activeIds = ['panel-0', 'panel-1']

    this.subscriptions.add(
      this.addinfoService.listenerSelectors().subscribe(selectors => {

        this.selectorObject = selectors;
        this.getAddinfoSpecifications();
        
      })
    );

    this.subscriptions.add(
      this.apiOrganizations.listenerCurrentOrganization().subscribe(val => {

        this.currentOrg = val;
        this.getAddinfoSpecifications();
      })
    );

    this.subscriptions.add(
      this.addinfoService.listenerFocusMissingField().subscribe((field) => {
        this.focusMissingField(field);
      })
    );

    this.initAddinfoForm();
    this.settingObjectDataWithDistribution();
    this.getAddinfoSpecifications();
    //this.getSelectors();
  }

  ngOnDestroy() {

    this.subscriptions.unsubscribe();
    this.subscriptionForm.unsubscribe();

    this.addinfoService.selectors = {};
    this.addinfoService.currentValue = [];
    this.addinfoService.addinfoGroupsSpec = [];

    this.objectData = {
      id: null,
      name: '',
      action: ''
    };
  }

  ngAfterViewChecked(): void {

    this.cdr.detectChanges();
  }


  /**
  * 
  * @param fieldName string
  * @param value Lang
  */
  eventFnFF(i: number, j: number, value: any): void {

    this.ffInputLang = value;
    this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).setValue(value.name);
  }


  /**
   * Заполнение objectData
   */
  settingObjectDataWithDistribution(): void {

    if (this.objectData.id != null) {

      this.objectData.id = +this.currentRoute.snapshot.paramMap.get('id');
    }

    if (!this.objectData.name && this.urlElements.length > 0) {

      this.objectData.name = this.urlElements[1];
      this.objectData.action = this.urlElements[2];

      if (!this.objectData.id) {

        if (this.urlElements.length >= 4) {

          this.objectData.id = this.urlElements[3];
        }
      }
    }
  }


  /**
   * Получение атрибутивной модели
   */
  getAddinfoSpecifications(): void {

    this.progressRef.start();
    this.isRefreshingSpecs = true;

    if (!this.currentOrg || !this.currentOrg.id) {
      this.progressRef.complete();
      this.isRefreshingSpecs = false;
      return;
    }

    this.selectorObject['org_id'] = this.currentOrg.id

    let params = {
      object: this.objectData.name,
      selectors: this.selectorObject
    }

    this.subscriptions.add(
      this.addinfoService.getAddinfoSpecifications(params).subscribe(response => {
        console.log("[ADDINFO] getAddinfoSpecifications response: ", response);


        if (response != null) {
          const nextGroups = response.result || [];
          this.applyProductCreateMandatoryOverrides(nextGroups);

          if(this.currentAction == 'edit'){
            this.activeIds = [];

            for(let i = 0; i < nextGroups.length; i++){

              this.activeIds.push('panel-' + i);
            }
          }

          this.addinfoGroups = nextGroups;
          this.addinfoService.addinfoGroupsSpec = nextGroups;
          console.log('[ADDINFO] addinfoGroups set, count=', this.addinfoGroups.length, 'activeIds=', this.activeIds, 'currentAction=', this.currentAction);


          this.gettedSpecificationsEvent.emit(this.addinfoGroups);

          //this.addinfoService.removeCurrentValue(this.addinfoGroups);

          if (this.objectData.action == this.action.edit) {

            this.getAddinfoData();
          }
          else if (this.objectData.action == this.action.create) {

            this.addGroupFields();
          }
        }

        this.isRefreshingSpecs = false;
        this.progressRef.complete();
      },
      () => {
        this.isRefreshingSpecs = false;
        this.progressRef.complete();
      })
    );
  }


  /**
   * Получение данных
   */
  getAddinfoData(): void {

    this.progressRef.start();

    let params = {
      object: this.objectData.name,
      object_id: this.objectData.id
    }

    this.subscriptions.add(
      this.addinfoService.getAddinfoData('addinfoEdit', params).subscribe(response => {
        console.log("[ADDINFO] getAddinfoData response: ", response);


        this.addinfoData = (response != null) ? (response.result || []) : [];
        console.log('[ADDINFO] addinfoData length=', this.addinfoData.length);

        if (this.addinfoData.length > 0) {

          this.passSecurity();
        }

        this.addGroupFields(this.addinfoData);
        console.log('[ADDINFO] form groups built, controls=', (this.addinfoForm.get('groups') as any).controls.length);

        this.gettedDataEvent.emit(this.addinfoData);

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  passSecurity() {

    let primitiveParams: string;

    for (let d of this.addinfoData) {

      for (let l of d.attributes) {

        if (l.attribute_type == 'TAGS' && l.tags != null) {

          for (let t of l.tags) {

            primitiveParams = t.graphic_primitive.primitive_params
            primitiveParams = primitiveParams.replace('color', t.color)
            t['tagHtml'] = this.sanitizer.bypassSecurityTrustHtml(primitiveParams) as SafeHtml;
          }
        }
      }
    }
  }


  /**
   * Обновление данных
   */
  updateAddinfoData(): void {

    // синхронизируем текущий снапшот формы для сервиса валидации
    this.addinfoService.addinfoFormValue = <any[]>this.addinfoForm.get('groups').value;

    const missing = this.addinfoService.getMissingRequiredFields();

    if (missing.length > 0) {

      const preview = missing.slice(0, 5).join(', ');
      const suffix = missing.length > 5 ? ` и ещё ${missing.length - 5}` : '';
      this.notification.show('warning', `Заполните обязательные поля: ${preview}${suffix}`);
      this.addinfoService.focusFirstMissingRequiredField();
      return;
    }

    this.progressRef.start();

    let data = {
      object: this.objectData.name,
      object_id: this.objectData.id,
      addinfo: this.addinfoService.typeConversionToString(<any[]>this.addinfoForm.get('groups').value)
    }

    console.log("DATA: ", data);


    this.subscriptions.add(
      this.addinfoService.updateAddinfoData(data).subscribe(response => {
        console.log('[RESPONSE] addinfoUpdate:', response);

        if (response != null) {

          this.updatedEvent.emit(true);

          // Сначала показываем уведомление, затем без разрушения формы тянем свежие данные,
          // чтобы избежать мигания: форма перестроится только после прихода новых данных внутри addGroupFields().
          this.notification.show('success', 'Данные успешно сохранены!');
          this.getAddinfoData();
        }
        this.progressRef.complete();
      })
    );
  }


  /**
   * !!! сейчас не требуется
   * Получаем список селекторов
   */
  getSelectors(): void {

    this.subscriptions.add(
      this.addinfoService.getSelectors().subscribe(response => {
        console.log('[RESPONSE] getSelectors:', response);

        if (response != null) {

          this.selectors = response.result;
          // this.getAddinfoData();
        }
      })
    );
  }


  /**
   * Инициирование формы
   */
  initAddinfoForm(): void {

    this.addinfoForm = this.fb.group({
      groups: this.fb.array([])
    });
  }


  /**
   * Добавление Групп в форму
   * @param addinfoData AddinfoDataGroup[]
   */
  addGroupFields(addinfoData: AddinfoDataGroup[] = []): void {

    this.addinfoForm.reset();
    this.initAddinfoForm();

    let control = <UntypedFormArray>this.addinfoForm.controls.groups;

    this.addinfoGroups.forEach((x, i) => {

      control.push(
        this.fb.group({
          attribute_group_id: [x.attribute_group_id],
          attributes: this.addAttrFields(x, i, addinfoData)
        })
      );
    });
    

    // работа с subscriptionForm требуется именно в этом место 
    if (this.subscriptionForm) this.subscriptionForm.unsubscribe();

    this.subscriptionForm = this.addinfoForm.valueChanges.subscribe(value => {

      this.addinfoService.preparationForCurrentValue(value);
      
    });
  }


  /**
   * Добавление Аттрибутов в Группу формы
   * @param x AddinfoGroup
   * @param i number
   * @param addinfoData AddinfoDataGroup[]
   * @returns FormArray
   */
  addAttrFields(x: AddinfoGroup, i: number, addinfoData: AddinfoDataGroup[]): UntypedFormArray {

    let attrFields = this.fb.array([]);
    let validator: any[] = [];
    let groupIndex: number;
    let attrIndex: number;
    let value: any;
    let attributeId: string;
    let id: string;
    let translation: boolean;
    // дополнительные поля для некоторых типов атрибута
    let files: FileData[] = [];
    let tags: any[] = []; //добавить модель
    let certificate: any;
    let images:any[] = [];

    x.attributes.forEach((y, j) => {

      validator = [];
      groupIndex = null;
      attrIndex = null;
      value = null;
      attributeId = null;
      id = null;
      translation = null;
      // дополнительные поля для некоторых типов атрибута
      images = [];
      files = [];
      tags = [];
      certificate = null;

      // подготовка данных для заполнения формы
      if (addinfoData.length > 0) {

        groupIndex = addinfoData.findIndex(val => val.attribute_group_id == x.attribute_group_id);

        if (groupIndex > -1) {

          attrIndex = addinfoData[groupIndex].attributes.findIndex(val => val.attribute_id == y.attribute_id);

          if (attrIndex > -1) {

            // выполняем преобразование типа данных поля value
            value = this.addinfoService.attrValueTypeConversion(y.attribute_value_type, addinfoData[groupIndex].attributes[attrIndex].attribute_value);
            value = this.addinfoService.attrTypeConversion(y.attribute_type, addinfoData[groupIndex].attributes[attrIndex].attribute_value);
            id = addinfoData[groupIndex].attributes[attrIndex].id;

            // дополнительные поля для некоторых типов атрибута
            files = addinfoData[groupIndex].attributes[attrIndex].file != null ? addinfoData[groupIndex].attributes[attrIndex].file : [];
            // images = addinfoData[groupIndex].attributes[attrIndex].file != null ? this.getImageContent(i, j, addinfoData[groupIndex].attributes[attrIndex].file[0].id) : [];
            tags = addinfoData[groupIndex].attributes[attrIndex].tags != null ? addinfoData[groupIndex].attributes[attrIndex].tags : [];
            certificate = addinfoData[groupIndex].attributes[attrIndex].certificate;

            if(addinfoData[groupIndex].attributes[attrIndex].file != null){

              this.getImageContent(i, j, addinfoData[groupIndex].attributes[attrIndex].file[0].id, 'edit');
            }
            
      
          }
        }
      }

      // определяем требуется ли полю валидация
      if (y.is_mandatory) {

        validator.push(Validators.required);
      }

      // добавление валидаторов и использование правил 
      // !!! (вынести работу с правилами отдельно от валидаторов)
      if (y.attribute_validation_rule != null) {

        validator.push(this.addinfoService.checkRules(this.addinfoForm, y));
      }

      // использование текущих значений
      let currentValue: any = this.addinfoService.getCurrentValue(x.attribute_group_id, y.attribute_id);

      if (currentValue != null) {

        id = currentValue.id;
        attributeId = currentValue.attribute_id;
        value = currentValue.attribute_value;
        translation = currentValue.translation;
        files = currentValue.files;
        images = currentValue.images;
        tags = currentValue.tags;
        certificate = currentValue.certificate;
        
      }
      else {

        attributeId = y.attribute_id;
        translation = y.translation;
      }

      // Nullify empty strings for combobox/date so ng-select/date inputs
      // show placeholder and do not render a phantom "clear" icon.
      const at = this.addinfoService.attrType;
      if ((y.attribute_type == at.combobox || y.attribute_type == at.date)
          && (value === '' || value === undefined)) {
        value = null;
      }

      // заполнения формы
      attrFields.push(
        this.fb.group({
          id: [id],
          attribute_id: [attributeId],
          attribute_value: [value, validator],
          translation: [translation],
          files: [files],
          images: [images],
          tags: [tags],
          certificate: [certificate]
        })
      );
      
    });

    return attrFields;
  }

  /**
 * 
 */
  uploadFile(i: number, j: number) {

    let data = {
      organizationId: this.apiOrganizations.currentOrganization.id,
      option: {
        multiple: false,
        component: 'products'
      }
    }

    this.dialogModal.open(data, UploadFileWithDateComponent, '', 'upload-file-window').then(
      
      (res) => {

        if (res.result) {

          this.getImageContent(i, j, res.result.id);
          this.setValueUploadedFile(i, j, res.result);

        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
  * @param i number
  * @param j number
  * @param attribute_id string
  */
  onUploadFileFromStorage(i: number, j: number): void {

    let data = {};

    this.dialogModal.open(data, DonwloadFileFromStorageComponent).then(

      (result) => {

        if (result) {

          this.getImageContent(i, j, result.id);
          this.setValueUploadedFile(i, j, result);

        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * Установка значения загруженного файла/ов
   * @param i number
   * @param j number
   * @param file FileData
   */
  // ! Cейчас из ff-button-upload-files только последний файл, НЕ МАССИВ.  
  // ! В случае если параметр multiple = true, возврат данных не корректный, требуется доработка в file-upload-process
  // ! Соответственно и во всех местах где используется кнопка загрузки файлов ff-button-upload-files требуется доработка по пулучению данных массивом
  setValueUploadedFile(i: number, j: number, file: FileData): void {

    let files: FileData[] = [];

    if (file) {

      files = [...this.addinfoForm.get(['groups', i, 'attributes', j, 'files']).value];
      files.push(file);

      this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).setValue(file.id);
      this.addinfoForm.get(['groups', i, 'attributes', j, 'files']).setValue(files);
    }
  }

   /**
   * 
   * @param index 
   * @param image 
   */
   getImageContent(i: number, j: number, file_id: any, type: string = ''): void {

    let images:any[] = [];

    let check = this.fileIds.findIndex(val => val == file_id);

    this.fileIds.push(file_id);

    // Проверка на дубликаты при загрузке данных в компоненте редактирование
    if(check > -1 && type == 'edit'){

      this.fileIds.splice(check, 1);

    }else{

      this.subscriptions.add(

        this.filesService.getImageContent(file_id).subscribe((response: any) => {
  
          if (response != null) {
  
            images = [...this.addinfoForm.get(['groups', i, 'attributes', j, 'images']).value];
            images.push(response.result);
  
            // this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).setValue(response.result);
            this.addinfoForm.get(['groups', i, 'attributes', j, 'images']).setValue(images);
  
          }
        })
      );
    }
    
  }


  /**
   * Удаление значения загруженного файла/ов
   * @param i number
   * @param j number
   * @param file FileData
   */
  deleteValueFromFiles(i: number, j: number, file: FileData): void {

    // предусматриваем что в attribute_value несколько значений
    let value: string = this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).value;
    let files: FileData[] = this.addinfoForm.get(['groups', i, 'attributes', j, 'files']).value;
    let fileIds: string[] = value != null ? value.split(',') : [];
    let positionId: number = fileIds.indexOf(file.id);
    let positionFile: number = files.indexOf(file);
    let images: any[] = this.addinfoForm.get(['groups', i, 'attributes', j, 'files']).value;

    // удаляем id из поля attribute_value
    if (~positionId) fileIds.splice(positionId, 1);
    this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).setValue(fileIds.join());

    // удаляем данные файла из поля files
    if (~positionFile) files.splice(positionFile, 1), images.splice(positionFile, 1);
    this.addinfoForm.get(['groups', i, 'attributes', j, 'files']).setValue(files);
    this.addinfoForm.get(['groups', i, 'attributes', j, 'images']).setValue(images);

  }


  /**
   * Скачивание файлов
   * @param file FileData
   */
  downloadFile(file: FileData): void {

    this.filesService.downloadFile(file.name, file.id);
  }


  /**
   * Открытие диалогового окна для создания и прикрепления Сертификата
   * !!! ТРЕБУЕТСЯ ДОРАБОТКА, ВЫБОР ИЗ УЖЕ РАНЕЕ ЗАГРУЖЕННЫХ СЕРТИФИКАТОВ/ФАЙЛОВ
   * @param i number
   * @param j number
   * @param attribute_id string
   */
  openDialogCreateCert(i: number, j: number, attribute_id: string): void {

    let data = {
      type: 'create',
      cert_type: attribute_id,
      product_ids: [],
    };

    this.dialogModal.open(data, AttachingCertificateComponent).then(
      (result) => {

        if (result) {
          
          this.getImageContent(i, j, result.file_id);

          this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).setValue(result.id);
          this.addinfoForm.get(['groups', i, 'attributes', j, 'certificate']).setValue(result);
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * Удаление(открепление) сертификата
   * @param i number
   * @param j number
   */
  deleteValueForCert(i: number, j: number): void {

    this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).setValue(null);
    this.addinfoForm.get(['groups', i, 'attributes', j, 'certificate']).setValue(null);
  }

  /**
   * 
   * @param i 
   * @param j 
   * @param attribute_id 
   */
  onCreateTags(i: number, j: number): void {

    let data = {
      tagsIds: this.addinfoForm.get(['groups', i, 'attributes', j, 'tags']).value.map(v => v.id)
    };
    

    this.dialogModal.open(data, TagsListComponent, '', 'tags-window').then(
      (result) => {

        if (result) {

          this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).setValue(result.map(t => t.id).join());
          this.addinfoForm.get(['groups', i, 'attributes', j, 'tags']).setValue(result);

        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   * @param styles 
   * @returns 
   */
  getTagStyle(styles) {
    return {
      width: styles.width + styles.width_height_unit,
      // height: styles.height + styles.width_height_unit,
      display: 'block',
      margin: '4px 10px 5px 5px'
    }
  }


  /**
   * Удаление(открепление) сертификата
   * @param i number
   * @param j number
   */
  deleteValueTags(i: number, j: number, tag: any): void {

    // предусматриваем что в attribute_value несколько значений
    let value: string = this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).value;
    let tags: FileData[] = this.addinfoForm.get(['groups', i, 'attributes', j, 'tags']).value;
    let tagsIds: string[] = value != null ? value.split(',') : [];
    let positionId: number = tagsIds.indexOf(tag.id);
    let positionTag: number = tags.indexOf(tag);

    // удаляем id из поля attribute_value
    if (~positionId) tagsIds.splice(positionId, 1);
    this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).setValue(tagsIds.join());

    // удаляем данные файла из поля files
    if (~positionTag) tags.splice(positionTag, 1);
    this.addinfoForm.get(['groups', i, 'attributes', j, 'files']).setValue(tags);
  }

  /**
   * 
   * @param fileName string
   * @returns string
   */
   checkIconExt(fileName: string): string {

    return this.filesService.checkIconExt(fileName);
  }

  /**
   * 
   * @param id 
   */
  getIntegrationValue(i: number, j: number, id: string): void{


    let checkIds = this.integrationIds.findIndex(val => val == id);

    if(checkIds > -1){

      this.integrationIds.splice(checkIds);

    }else{
      
      this.integrationIds.push(id);
      this.addinfoForm.get(['groups', i, 'attributes', j, 'attribute_value']).setValue(this.integrationIds.map(t => t).join());
    }

    
    console.log("CHECK BOX VALUE: ", this.integrationIds);
    
  }

  getActiveId(id: string, index: number): void{

    
  }

  private focusMissingField(field: any): void {

    if (!field || !field.groupId || !field.attributeId) return;

    const groupIndex = this.addinfoGroups.findIndex(g => g && g.attribute_group_id === field.groupId);
    if (groupIndex < 0) return;

    const panelId = `panel-${groupIndex}`;
    if (!this.activeIds.includes(panelId)) {
      this.activeIds = [...this.activeIds, panelId];
    }
    this.isClicked[groupIndex] = true;

    setTimeout(() => {
      const selector = `[data-addinfo-group-id="${field.groupId}"][data-addinfo-attr-id="${field.attributeId}"]`;
      const container = document.querySelector(selector) as HTMLElement | null;
      if (!container) return;

      container.scrollIntoView({ behavior: 'smooth', block: 'center' });

      const focusCandidate = container.querySelector('input, textarea, select, [tabindex]') as HTMLElement | null;
      if (focusCandidate) {
        focusCandidate.focus();
      }
    }, 150);
  }

  /**
   * Локальные переопределения обязательности полей для конкретных экранов.
   * На создании товара поле "Товарная позиция" должно быть необязательным.
   */
  private applyProductCreateMandatoryOverrides(groups: AddinfoGroup[]): void {

    if (this.objectData.name !== 'products' || !Array.isArray(groups)) {
      return;
    }

    // На редактировании товара обязательность полей полностью отключена по требованию.
    if (this.objectData.action === this.action.edit) {
      groups.forEach((group: AddinfoGroup) => {
        if (!group || !Array.isArray(group.attributes)) return;
        group.attributes.forEach((attr: any) => {
          if (attr) attr.is_mandatory = false;
        });
      });
      return;
    }

    // На создании товара "Товарная позиция" должна быть необязательной.
    if (this.objectData.action !== this.action.create) {
      return;
    }

    groups.forEach((group: AddinfoGroup) => {
      if (!group || !Array.isArray(group.attributes)) return;

      group.attributes.forEach((attr: any) => {
        if (!attr || typeof attr.attribute_name !== 'string') return;

        const normalizedName = attr.attribute_name.toLowerCase().trim();
        if (normalizedName === 'товарная позиция') {
          attr.is_mandatory = false;
        }
      });
    });
  }
}
